/** Below this size a download keeps the staged path and shows no save picker. */
export const STREAMING_SAVE_MIN_FILE_SIZE_GB = 2;

export const STREAMING_SAVE_START_IN = 'downloads';

export const STREAMING_SAVE_PICKER_ID = 'syncDownload';
